module.exports = __webpack_public_path__ + "static/media/icon-character__francisco-franco.20d4243b.svg";